<script setup lang="ts">
import { computed } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@/stores/auth';
import AppShell from '@/layouts/AppShell.vue';

const { t } = useI18n();
const route = useRoute();
const auth = useAuthStore();

const showChrome = computed(() => auth.isAuthenticated && route.meta.chrome !== false);

// The router guard restores the session before the first navigation resolves; a second
// call here would rotate the refresh token twice on one page load.
</script>

<template>
  <div v-if="auth.initialising" class="shio-boot">
    <p class="shio-boot__mark shio-wordmark">Shio<b>Cast</b></p>
    <p class="shio-meta">{{ t('shell.restoring') }}</p>
  </div>

  <AppShell v-else-if="showChrome">
    <RouterView />
  </AppShell>

  <RouterView v-else />
</template>

<style scoped>
.shio-boot {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--shio-space-3);
}

.shio-boot__mark {
  font-size: 34px;
  margin: 0;
}
</style>
